export const enum componentLoaderTestIds {
  ELEMENT = "loader-element",
}

export enum responseErrorAlertTestIds {
  CONTAINER_ELEMENT = "response-error-alert-container-element",
}
